<template>
  <pull-to class="eds-flow-info-root" :style="{ height: height }" :top-load-method="refresh"
    :top-config="TOP_DEFAULT_CONFIG" :bottom-config="BOTTOM_DEFAULT_CONFIG">
    <div style="text-align: center; color: red" v-if="handleFlag">
      {{ handleTitle }}
    </div>
    <v-divider></v-divider>
    <div class="flow_content_main" v-if="flowInfo">
      <template v-if="isEn">
        <img v-if="flowInfo.state == 'approved'" style="float: right; z-index: 1999"
          src="imgs/svg/eds/icon_approved_en.svg" />
        <img v-else-if="flowInfo.state == 'rejected'" style="float: right; z-index: 1999"
          src="imgs/svg/eds/icon_rejected_en.svg" />
      </template>
      <template v-else>
        <img v-if="flowInfo.state == 'approved'" style="float: right; z-index: 1999"
          src="imgs/svg/eds/icon_approved.svg" />
        <img v-else-if="flowInfo.state == 'rejected'" style="float: right; z-index: 1999"
          src="imgs/svg/eds/icon_rejected.svg" />
      </template>
      <div class="eds_content2">
        <span class="eds_content_prop"> {{ $t('发起人') }} </span>
        <span class="eds_content_value">{{ flowInfo.userName }}</span>
        <span class="eds_content_value" v-if="isDev">({{ flowInfo.id + $t('测试') }})</span>
      </div>
      <div class="eds_content2">
        <span class="eds_content_prop">{{ $t('所在部门') }}</span>
        <span class="eds_content_value">{{ flowInfo.orgName }}</span>
      </div>
      <div class="eds_content2">
        <span class="eds_content_prop">{{ $t('申请标题') }}</span>
        <span class="eds_content_value">{{ flowInfo.title }}</span>
      </div>
      <div class="eds_content2">
        <span class="eds_content_prop">{{ $t('申请描述') }}</span>
        <span class="eds_content_value">{{ flowInfo.desc }}</span>
      </div>
      <div class="eds_content2">
        <span class="eds_content_prop">{{ $t('文件') }}</span>
        <span class="eds_content_value flow_file_value">
          <div v-for="(file, index) in flowInfo.files" :key="index" class="flow_file"
            :class="{ 'is-current-file': currentFileId === file.id, }" @click="(e) => onFlowFileClick(file, e)">
            <div class="flow_file_infos">
              <eds-file-icon :fileName="file.name" />
              <div class="flow_file_info">{{ file.name }}</div>
              <div class="flow_file_info--size" v-if="file.size / 1024 > 1024">
                {{ (file.size / 1024 / 1024).toFixed(0) }}M
              </div>
              <div class="flow_file_info--size" v-else>
                {{ (file.size / 1024).toFixed(0) }}KB
              </div>
            </div>
            <div class="flow_file_download">
              <v-btn v-if="allowDownload" :disabled="disabledDownload(file)" round small
                @click.stop="onOpenFile(file)">{{ $t('预览') }}</v-btn>
            </div>
          </div>
        </span>
      </div>
    </div>
    <v-stepper class="flow_step" v-if="flowInfo" :value="step" vertical>
      <v-stepper-step :complete="true" step="0">
        {{ $t('提交') }}
        <small>{{ flowInfo.userName + ' ' +  $t('提交') }}</small>
        <div class="flow-step__time">
          {{ convertDate(flowInfo.createTime) }}
        </div>
      </v-stepper-step>
      <v-stepper-content step="0"></v-stepper-content>
      <template v-for="(task, index) in mergeTasks">
        <template v-if="task.state == 'approved' || task.state == 'rejected'">
          <v-stepper-step :key="index" :complete="true" :step="task.id ? task.id : 0">
            {{ $t(TASK_Type[task.type].name) }}
            <small v-if="task.note">{{
              `${task.userName}  ${task.state === 'approved' ? $t('已同意') : $t('已拒绝')
              }`
            }}</small>
            <div class="flow-step__time">
              {{ convertDate(task.processTime) }}
            </div>
          </v-stepper-step>
          <!--产生连线效果 -->
          <v-stepper-content :key="'content' + index" :step="task.id ? task.id : 0"></v-stepper-content>
        </template>
        <template v-if="task.state == 'awaiting' || task.state == 'initialized'">
          <v-stepper-step :key="index" :complete="false" :step="task.isMergeTask ? '···' : task.userName.substring(1)">
            {{ $t(TASK_Type[task.type].name) +
              (isDev ? '（level =' + task.level + $t('测试') + '）' : '')
            }}
            <small v-if="task.note">{{ task.userName + task.note }}</small>
            <small v-else>{{ $t('等待') + ' ' + task.userName + ' ' + $t(TASK_Type[task.type].name) }}</small>
            <div v-if="task.processTime" class="flow-step__time">
              {{ convertDate(task.processTime) }}
            </div>
          </v-stepper-step>
          <!--产生连线效果 -->
          <v-stepper-content :key="'content' + index" :step="task.id ? task.id : 0"></v-stepper-content>
        </template>
        <template v-if="task.state == 'discarded'"> </template>
      </template>
    </v-stepper>
    <!-- <div class="eds_div_openfile_loading" v-if="openFileLoading"></div> -->
    <v-dialog persistent v-if="openFileLoading" :value="openFileLoading" @input="openFileLoading" max-width="80px"
      max-height="80px">
      <v-progress-circular class="eds_progress_openfile_loading" v-if="openFileLoading" :size="50" color="blue"
        indeterminate></v-progress-circular>
    </v-dialog>
  </pull-to>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import PullTo from 'vue-pull-to'
import APP_CONFIG from '../../config/App'
import devHelper from '../../util/devHelper'
import dateHelper from '../../util/date'
import msgbus from '../../msgBus'
import functions from '../../functions'
import { TASK_TYPE } from '../../config/work'
import { styleNo } from '../../config/BottomBtn'
import eDSCompMyTaskList from '../../components/eDSCompMyTaskList'
import eDSCompMyApplicationList from '../../components/eDSCompMyApplicationList'
import edsFileIcon from '@/components/edsFileIcon'


export default {
  name: 'eDSFlowInfo',
  components: {
    PullTo,
    eDSCompMyTaskList,
    eDSCompMyApplicationList,
    edsFileIcon,
  },
  data() {
    return {
      TOP_DEFAULT_CONFIG: APP_CONFIG.tTOP_DEFAULT_CONFIG(),
      BOTTOM_DEFAULT_CONFIG: APP_CONFIG.tBOTTOM_DEFAULT_CONFIG(),
      title: this.$t('流程'),
      handleFlag: false,
      handleTitle: this.$t('等待我审批'),
      allowDownload: false,
      step: 2, // 当前步骤
      TASK_Type: TASK_TYPE,
      bottomButtons: [],
      flowID: '', // 流程编号
      flowTid: '', // 当前流程所属租户tid
      flowTname: '', // 当前流程所属租户tname
      userOID: '', // 登录账户在当前租户的用户OID
      flowInfo: null, // 流程信息
      mergeTasks: [],
      currentFileId: null, // 当前文件Id(可换行显示文件名)

      // 流程信息（测试数据）
      flowInfo1: {
        id: 514,
        name: '陈雪峰提交的文件解密申请',
        title: '文件解密申请',
        desc: '测试的文件解密审批流程-测试的文件解密审批流程-测试的文件解密审批流程-测试的文件解密审批流程',
        type: 'file_dec',
        createTime: 1597029272,
        state: 'awaiting_approval',
        step: '等待文件解密',
        fileBrief: '待审批文件.docx;...',
        templateID: 1,
        templateName: '文件解密申请',
        mailFrom: 'from@hzdatalink.com',
        mailTo: 'to@hzdatalink.com;to2@hzdatalink.com',
        mailCC: '',
        userOID: 10635,
        userName: '陈雪峰',
        orgName: '研发部',
        orgOID: '8935',
        tasks: [
          {
            type: 'approval',
            state: 'approved',
            userName: '章北海',
            userOID: 10680,
            level: 3,
            allowDownload: false,
            allowFinish: false,
          },
          {
            type: 'download',
            state: 'awaiting',
            userName: '陈雪峰',
            userOID: 10635,
            level: 0,
            allowDownload: true,
            allowFinish: true,
          },
        ],
        files: [
          {
            id: 16687,
            name: '测试文件.xlsx',
            url: 'https://pan.hzdatalink.com/api/alien/download/3386c048-551b-464c-64e0-347d1d3df742/测试文件.xlsx',
            size: 130048,
          },
          {
            id: 16688,
            name: '测试文件.docx',
            url: 'https://pan.hzdatalink.com/api/alien/download/5a2d11e8-29aa-4e0d-76cb-d4926c9fb16e/测试文件.docx',
            size: 22039,
          },
        ],
      },
      flowInfo2: {
        id: 515,
        name: '陈雪峰提交的文件解密申请',
        title: '文件解密申请',
        desc: '测试的文件解密审批流程-测试的文件解密审批流程-测试的文件解密审批流程-测试的文件解密审批流程',
        type: 'file_dec',
        createTime: 1597029272,
        // state: 'awaiting_approval',
        state: 'approved',
        step: '等待文件解密',
        fileBrief: '待审批文件.docx;...',
        templateID: 1,
        templateName: '文件解密申请',
        mailFrom: 'from@hzdatalink.com',
        mailTo: 'to@hzdatalink.com;to2@hzdatalink.com',
        mailCC: '',
        userOID: 10635,
        userName: '陈雪峰',
        orgName: '研发部',
        orgOID: '8935',
        tasks: [
          {
            id: 1256,
            type: 'approval',
            createTime: 1597029272,
            state: 'approved',
            userName: '陈雪峰',
            userOID: 10635,
            level: 1,
            note: '同意',
            processTime: 1597031224,
            allowDownload: true,
            allowFinish: true,
          },
          {
            type: 'download',
            state: 'awaiting',
            userName: '陈雪峰',
            userOID: 10635,
            level: 0,
            allowDownload: true,
            allowFinish: true,
          },
        ],
        files: [
          {
            id: 16687,
            name: '测试文件.xlsx',
            url: 'https://pan.hzdatalink.com/api/alien/download/3386c048-551b-464c-64e0-347d1d3df742/测试文件.xlsx',
            size: 130048,
          },
          {
            id: 16688,
            name: '测试文件.docx',
            url: 'https://pan.hzdatalink.com/api/alien/download/5a2d11e8-29aa-4e0d-76cb-d4926c9fb16e/测试文件.docx',
            size: 22039,
          },
        ],
      },
      taskInfo: null,
    }
  },
  computed: {
    isDev() {
      return devHelper.isDevMode() // 判断是否开启了测试模式
    },
    height() {
      if (this.bottomButtons) {
        return `calc(${window.innerHeight}px - 48px - 36px ` + ')'
      } else {
        return `calc(${window.innerHeight}px - 48px ` + ')'
      }
    },
    openFileLoading() {
      return msgbus.vm.getIsDownloading()
    },
    isZh() {
      return this.$i18n.locale == 'zh'
    },
    isEn() {
      return this.$i18n.locale == 'en'
    }
  },
  methods: {
    onFlowFileClick(file, e) {
      if (this.currentFileId === file.id) {
        this.currentFileId = ''
      } else {
        this.currentFileId = file.id
      }
    },
    goBack() {
      // setBackDisabled会清空特殊路由信息，因此调用之前先读取是否特殊路由信息
      const backSpecialRoute = msgbus.vm.getBackSpecialRoute()
      msgbus.vm.setBackDisabled(true)

      // 若有特殊路由设置信息，则调转到指定页面
      if (backSpecialRoute) {
        this.$router.replace({ name: backSpecialRoute })
      } else {
        this.$router.back()
      }
    },
    // 能否下载（根据后缀，文件大小，判断能否下载）
    disabledDownload(file) {
      let disabledDownload = false
      // 大小限制（100M/ 1,048,576）
      if (file.size / 1024 / 1024 > 100) {
        disabledDownload = true
      } else {
        // 后缀暂定： doc docx ppt pptx xls xlsx txt pdf epub dwg
        let canExts = []
        if (msgbus.vm.getPlatform() == 'Android') {
          canExts.push(...[
            'doc',
            'docx',
            'ppt',
            'pptx',
            'xls',
            'xlsx',
            'txt',
            'pdf',
            'epub',
            'dwg',
          ])
        } else if (msgbus.vm.getPlatform() == 'iOS') {
          canExts.push(...[
            'doc',
            'docx',
            'ppt',
            'pptx',
            'xls',
            'xlsx',
            'txt',
            'pdf',
            'epub',
          ])
        }
        let fileExtension = file.name
          .substring(file.name.lastIndexOf('.') + 1)
          .toLowerCase()
        let filter = canExts.filter((canExt) => canExt === fileExtension)
        if (filter.length == 0) {
          disabledDownload = true
        }
      }
      return disabledDownload
    },
    // 预览文件
    onOpenFile(file) {
      if (msgbus.vm.getPlatform() == 'browser') {
        msgbus.vm.setSnackBar({
          value: {
            color: 'error',
            text: this.$t('预览仅支持Android和IOS系统'),
            visible: true,
          },
        })
        if (sessionStorage.__debug === 'true') {
          msgbus.vm.setRequestStorage({
            value: {
              visible: true,
              callback: (granted) => {
                console.debug(granted)
              }
            }
          })
        }
      } else {
        var fileName = this.flowTid + '+' + file.id + '+' + file.name

        functions.sqliteHelper.queryFile(1, fileName).then((resultSet) => {
          if (
            resultSet.rows.length > 0 &&
            resultSet.rows.item(0).downloadPer == 100
          ) {
            // 直接打开文件
            let fileInfo = {
              isFlowFile: resultSet.rows.item(0).isFlowFile, // 标识是否流程文件 1 是，0 不是
              fileWholeName: resultSet.rows.item(0).fileWholeName, // 路径+文件名
              fileName: resultSet.rows.item(0).fileName, // 文件名
              flowID: resultSet.rows.item(0).flowID, // 流程ID
              flowName: resultSet.rows.item(0).flowName, // 流程名称
              flowFileURL: resultSet.rows.item(0).flowFileURL, // 流程文件下载URL
              flowFileName: resultSet.rows.item(0).flowFileName, // 流程文件名
              encrypted: resultSet.rows.item(0).encrypted, // 文件是否加密
              key: resultSet.rows.item(0).key, // 打开加密文件所用的密钥
              userOID: resultSet.rows.item(0).userOID, // 用户OID
              orgID: resultSet.rows.item(0).orgID, // 组织OID
              clID: resultSet.rows.item(0).clID, // 文件密级
              fileID: resultSet.rows.item(0).fileID, // 文件ID,
              tid: resultSet.rows.item(0).tid,
              tname: resultSet.rows.item(0).tname,
              downloadPer: resultSet.rows.item(0).downloadPer,
            }
            // 写Sqlite本地数据库打开文件信息
            functions.edsfileview.funcWriteSqlite(fileInfo)
            //打开文件
            functions.edsfileview.funcFileBrowsing(fileInfo)
          } else {
            // 置正在下载标记true
            msgbus.vm.setIsDownloading({ value: true })
            // 下载并打开文件
            let fileInfo = {
              isFlowFile: 1,
              fileWholeName: '',
              fileName: fileName, // 文件名（物理文件名）
              flowID: this.flowInfo.id, // 流程ID
              flowName: this.flowInfo.name, // 流程名称
              flowFileURL: file.url, // 流程文件下载URL
              flowFileName: file.name, // 流程文件名
              tid: this.flowTid,
              tname: this.flowTname,
              fileID: file.id,
            }
            functions.edsdownloadfileHelper.funcEdsDownloadFile(
              1, // 1 标识下载完成后打开文件
              fileInfo
            )
          }
        })
      }
    },
    // 拒绝
    onRefuse() {
      this.taskInfo.flowName = this.flowInfo.name
      this.$router.push({
        name: 'taskrefuse',
        params: { taskInfo: this.taskInfo, taskTid: this.flowTid },
      })
    },
    //同意
    onAgree() {
      this.taskInfo.flowame = this.flowInfo.name
      this.$router.push({
        name: 'taskagree',
        params: { taskInfo: this.taskInfo, taskTid: this.flowTid },
      })
    },
    //直接完成
    onFinish() {
      this.$router.push({
        name: 'flowfinish',
        params: { flowInfo: this.flowInfo, flowTid: this.flowTid },
      })
    },
    // 转化时间
    convertDate(time) {
      return dateHelper.timestamp2LocalTime(time).substr(5)
    },
    // 刷新界面
    refresh(loaded) {
      // 启用测试数据
      // this.flowInfo = this.flowID == 514 ? this.flowInfo1 : this.flowInfo2
      // // 界面显示处理
      // this.showFlowInfo()
      // // 切换界面样式
      // this.changeView()

      // 根据流程编号，查询流程信息
      msgbus.vm
        .fetchFlowInfo({
          authorization: {
            Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
          },
          tid: this.flowTid,
          flowID: this.flowID,
          vm: msgbus.vm,
        })
        .then(
          () => {
            this.flowInfo = msgbus.vm.getFlowInfo()
            if (loaded != null) {
              loaded('done')
            }
            // 界面显示处理
            this.showFlowInfo()
            // 切换界面样式
            this.changeView()
          },
          () => {
            if (loaded != null) {
              loaded('fail')
            }
          }
        )
    },
    // 切换界面样式
    changeView() {
      msgbus.vm.setTitle(this.title)
      msgbus.vm.setTitleVisible(true)
      msgbus.vm.setBackDisabled(false)
      msgbus.vm.setBackIcon('arrow_back')
      msgbus.vm.setMsgInputVisible(false)
      msgbus.vm.setBottomNavVisible(false)
      if (this.bottomButtons.length > 0) {
        msgbus.vm.setBottomBtnVisible(true)
        msgbus.vm.setBottomBtn({ value: this.bottomButtons })
        msgbus.vm.setContentHeight({
          value: `calc(${window.innerHeight}px - 48px - 36px ` + ')',
        })
      } else {
        msgbus.vm.setBottomBtnVisible(false)
        msgbus.vm.setContentHeight({
          value: `calc(${window.innerHeight}px - 48px ` + ')',
        })
      }
    },
    // 显示流程信息
    showFlowInfo() {
      this.title = this.flowInfo.name

      //1、 判断是否有文件下载能力：流程中只要有一个任务是当前用户的，且该任务用户允许下载，则可以下载
      var taskTemp = this.flowInfo.tasks.filter(
        (task) => task.userOID == this.userOID && task.allowDownload
      )
      if (taskTemp && taskTemp.length > 0) {
        this.allowDownload = true
      }

      //2、判断流程当前任务是否是当前登录用户，若是，则进行操作命令识别
      taskTemp = this.flowInfo.tasks.filter(
        (task) => task.state == 'awaiting' && task.userOID == this.userOID
      )
      if (taskTemp && taskTemp.length > 0) {
        this.taskInfo = taskTemp[0]

        this.handleFlag = true

        switch (this.taskInfo.type) {
          case 'approval':
            this.handleTitle = this.$t('等待我审批')
            this.bottomButtons = this.taskInfo.allowFinish
              ? [
                {
                  primary: false,
                  title: this.$t('拒绝'),
                  style: styleNo[3],
                  func: this.onRefuse,
                  params: '',
                },
                // {
                //   primary: false,
                //   title: this.$t('直接完成'),
                //   style: styleNo[3],
                //   func: this.onFinish,
                //   params: '',
                // },
                {
                  primary: true,
                  title: this.$t('同意'),
                  style: styleNo[3],
                  func: this.onAgree,
                  params: '',
                },
              ]
              : [
                {
                  primary: false,
                  title: this.$t('拒绝'),
                  style: styleNo[2],
                  func: this.onRefuse,
                  params: '',
                },
                {
                  primary: true,
                  title: this.$t('同意'),
                  style: styleNo[2],
                  func: this.onAgree,
                  params: '',
                },
              ]
            break
          case 'download':
            this.handleTitle = this.$t('等待我下载解密')
            this.bottomButtons = [
              {
                primary: false,
                title: this.$t('请至pc端下载解密'),
                style: styleNo[1],
                func: null,
                params: '',
              },
            ]
            break
        }
      }

      // 对流程的任务进行显示处理（未审批的同级任务合并显示）
      let tasksTmp = []
      let levelsTmp = []
      let mergeTasksTmp = []
      let mergeTaskTmp = {}

      // 过滤出所有'awaiting'状态的任务
      tasksTmp = this.flowInfo.tasks.filter(
        (task) => task.state == 'awaiting' || task.state == 'initialized'
      )
      // 获取所有的等级信息
      tasksTmp.forEach((task) => {
        if (levelsTmp.indexOf(task.level) == -1) {
          levelsTmp.push(task.level)
        }
      })
      // 按等级信息，合并任务
      levelsTmp.forEach((level) => {
        let sameLevelTasks = tasksTmp.filter((task) => task.level == level)
        mergeTaskTmp = { ...sameLevelTasks[0] }
        sameLevelTasks.splice(0, 1)
        sameLevelTasks.forEach((task) => {
          mergeTaskTmp.userName += ',' + task.userName
        })
        mergeTaskTmp.isMergeTask = true
        mergeTasksTmp.push(mergeTaskTmp)
      })

      this.mergeTasks = [
        ...this.flowInfo.tasks.filter(
          (t) => !(t.state === 'awaiting' || t.state === 'initialized')
        ),
        ...mergeTasksTmp,
      ]
      this.step =
        this.mergeTasks.filter(
          (t) => t.state == 'approved' || t.state == 'rejected'
        ).length + 1
    },
  },
  created() {
    console.log('调试代码')
    if (msgbus.vm.getAccountToken() == null) {
      window.location.href = '/'
      return
    }
    // 初始置正在下载标记false
    msgbus.vm.setIsDownloading({ value: false })

    // 如果有路由参数，则读取路由参数：当前流程编号\流程对应的租户tid，否则从store中读取当前流程信息
    if (this.$route.params.flowID && this.$route.params.flowID != '') {
      this.flowID = this.$route.params.flowID
      this.flowTid = this.$route.params.flowTid
      // 保存当前流程信息
      msgbus.vm.setCurrentFlow({
        value: {
          flowID: this.flowID,
          flowTid: this.flowTid,
        },
      })
    } else {
      let currentFlow = msgbus.vm.getCurrentFlow()
      this.flowID = currentFlow.flowID
      this.flowTid = currentFlow.flowTid
    }
    this.flowTname = functions.login.funcGetTnameBaseTid(this.flowTid)
    this.userOID = functions.login.funcGetUserOIDBaseTid(this.flowTid)

    // 刷新界面
    this.refresh((result) => {
      if (result === 'fail') {
        setTimeout(() => {
          this.goBack()
        }, 2000)
      }
    })
  },
  mounted() { },
  beforeDestroy() {
    msgbus.vm.setMenuDisabled(true)
    msgbus.vm.setMenuItems([])
    msgbus.vm.setMenuIcon('')
  },
}
</script>

<style lang="scss">
.eds-flow-info-root {
  background-color: #ffffff;

  .flow_content_main {
    padding: 10px;

    .flow_file_value {
      overflow: hidden;

      .flow_file {
        display: flex;
        background: rgba(243, 243, 243, 1);
        border-radius: 4px;

        &+.flow_file {
          margin-top: 8px;
        }

        .flow_file_infos {
          flex: 1 1 auto;
          overflow: hidden;
          padding: 4px 0 0 46px;
          position: relative;

          .eds-file-icon {
            position: absolute;
            left: 10px;
            top: 10px;
          }

          .flow_file_info {
            color: rgba(56, 56, 56, 1);
            overflow: hidden; // 溢出隐藏
            text-overflow: ellipsis; // 规定文本不进行换行
            white-space: nowrap; // 当对象内文本溢出时，显示省略标记(…)
          }

          .flow_file_info--size {
            color: rgba(138, 138, 138, 1);
            font-size: 12px;
            overflow: hidden; // 溢出隐藏
            text-overflow: ellipsis; // 规定文本不进行换行
            white-space: nowrap; // 当对象内文本溢出时，显示省略标记(…)
          }
        }

        .flow_file_download {
          flex: none;

          & .v-btn {
            padding: 0 !important;
            margin-top: 10px;
            min-width: 43px;
            height: 21px;

            .v-btn__content {
              width: 40px;
            }
          }
        }

        &.is-current-file {
          &>.flow_file_infos {
            &>.flow_file_info {
              white-space: normal;
            }
          }
        }
      }
    }
  }

  .flow_step {
    clear: left;
    box-shadow: 0 -1px 3px -3px rgba(0, 0, 0, 0.2);

    & .v-stepper__step {
      .v-stepper__label {
        color: #383838;
        font-size: 14px;

        &>small {
          color: #8a8a8f;
          font-size: 14px;
        }

        & .flow-step__time {
          font-size: 12px;
          color: #c4c4c4;
          position: absolute;
          right: 10px;
        }
      }
    }
  }
}
</style>
